export default __webpack_public_path__ + "73d111795ee199f163971bb186aedd41.wav";